module.exports = __webpack_public_path__ + "img/img.f10b5e5f.png";